(() => {
  if (window.__fpHomeCleanV13Loaded) return;
  window.__fpHomeCleanV13Loaded = true;

  const isHome = () => document.body && document.body.classList.contains('template-index');
  const railItems = (rail) => rail._fpItems || (rail._fpItems = Array.from(rail.querySelectorAll(':scope > [data-fp-rail-item]')));
  const railDots = (rail) => {
    if (rail._fpDots) return rail._fpDots;
    const section = rail.closest('.fp-home-section');
    return (rail._fpDots = section ? Array.from(section.querySelectorAll('[data-fp-dots] .fp-home-dot')) : []);
  };

  function measure(rail) {
    const cards = railItems(rail);
    const dots = railDots(rail);
    if (!cards.length || !dots.length) return null;

    const railRect = rail.getBoundingClientRect();
    const center = railRect.left + railRect.width / 2;
    let active = 0;
    let min = Infinity;

    for (let i = 0; i < cards.length; i += 1) {
      const rect = cards[i].getBoundingClientRect();
      const distance = Math.abs(rect.left + rect.width / 2 - center);
      if (distance < min) {
        min = distance;
        active = i;
      }
    }
    return { dots, active };
  }

  function apply(state) {
    if (!state) return;
    state.dots.forEach((dot, index) => {
      const on = index === state.active;
      dot.classList.toggle('is-active', on);
      if (on) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  }

  function update(rail) {
    apply(measure(rail));
  }

  function refresh(root = document) {
    if (!isHome()) return;
    const rails = Array.from(root.querySelectorAll('[data-fp-rail]'));
    const states = rails.map(measure);
    states.forEach(apply);
  }

  function goTo(rail, index) {
    const card = railItems(rail)[index];
    if (!card) return;
    const railRect = rail.getBoundingClientRect();
    const cardRect = card.getBoundingClientRect();
    rail.scrollBy({
      left: cardRect.left + cardRect.width / 2 - (railRect.left + railRect.width / 2),
      behavior: 'smooth'
    });
  }

  function setupMouseRail(rail) {
    if (rail.dataset.fpMouseReady === '1') return;
    rail.dataset.fpMouseReady = '1';

    let dragging = false;
    let moved = false;
    let startX = 0;
    let startScroll = 0;

    let capturedPointerId = null;

    rail.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;

      /* Do not hijack native clicks on card controls. */
      if (event.target.closest('button, add-to-cart, [data-wishlist-toggle], [data-quick-view-button], input, select, textarea, summary')) {
        dragging = false;
        moved = false;
        return;
      }

      dragging = true;
      moved = false;
      capturedPointerId = null;
      startX = event.clientX;
      startScroll = rail.scrollLeft;
    });

    rail.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      const delta = event.clientX - startX;

      if (!moved && Math.abs(delta) > 5) {
        moved = true;
        rail.classList.add('is-mouse-dragging');
        capturedPointerId = event.pointerId;
        try { rail.setPointerCapture(event.pointerId); } catch (_) {}
      }

      if (!moved) return;

      rail.scrollLeft = startScroll - delta;
      event.preventDefault();
    });

    const finishDrag = (event) => {
      if (!dragging) return;
      dragging = false;
      rail.classList.remove('is-mouse-dragging');
      if (capturedPointerId !== null) {
        try { rail.releasePointerCapture(capturedPointerId); } catch (_) {}
      }
      capturedPointerId = null;
    };
    rail.addEventListener('pointerup', finishDrag);
    rail.addEventListener('pointercancel', finishDrag);
    rail.addEventListener('pointerleave', (event) => {
      if (dragging && event.buttons === 0) finishDrag(event);
    });

    rail.addEventListener('click', (event) => {
      if (!moved) return;
      event.preventDefault();
      event.stopPropagation();
      moved = false;
    }, true);

    rail.addEventListener('wheel', (event) => {
      if (rail.scrollWidth <= rail.clientWidth + 2) return;

      /* Never trap normal page scrolling. Native trackpad horizontal gestures
         keep working; Shift + wheel is the optional desktop horizontal control. */
      if (!event.shiftKey) return;

      const max = rail.scrollWidth - rail.clientWidth;
      const delta = Math.abs(event.deltaY) >= Math.abs(event.deltaX) ? event.deltaY : event.deltaX;
      const next = Math.max(0, Math.min(max, rail.scrollLeft + delta));
      if (Math.abs(next - rail.scrollLeft) < 1) return;

      event.preventDefault();
      rail.scrollLeft = next;
    }, { passive: false });
  }

  function setup(rail) {
    if (rail.dataset.fpV13Ready === '1') return;
    rail.dataset.fpV13Ready = '1';

    railItems(rail);
    setupMouseRail(rail);
    railDots(rail).forEach((dot, index) => dot.addEventListener('click', () => goTo(rail, index)));

    rail.addEventListener('scroll', () => {
      if (rail._fpV13Tick) return;
      rail._fpV13Tick = true;
      requestAnimationFrame(() => {
        rail._fpV13Tick = false;
        update(rail);
      });
    }, { passive: true });
  }

  function init(root = document) {
    if (!isHome()) return;
    root.querySelectorAll('[data-fp-rail]').forEach(setup);
    requestAnimationFrame(() => refresh(root));
  }

  function start() {
    if (!isHome()) return;
    init(document);
    let resizeFrame = 0;
    window.addEventListener('resize', () => {
      if (resizeFrame) return;
      resizeFrame = requestAnimationFrame(() => {
        resizeFrame = 0;
        refresh(document);
      });
    }, { passive: true });

    document.addEventListener('shopify:section:load', (event) => init(event.target || document));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();